<script setup>
import { ref, watch } from 'vue';
import { useMainStore } from '../../../../stores/index';
import { useKanbanStore } from '@/stores/kanban';
import ModalMain from './ModalMain.vue';
import ModalResponsable from './ModalResponsable.vue';
import ModalCopy from './ModalCopy.vue';
import ModalDelete from './ModalDelete.vue';
import TodoListUpdated from './TodoListUpdate.vue';
import moment from 'moment';

const emit = defineEmits(['taskDescription']);

const Store = useMainStore();
const kanbanStore = useKanbanStore();

const viewDocument = ref(null);
const modalResponsable = ref(null);
const ModalCopyRef = ref(null);
const ModalDeleteRef = ref(null);
const fileInput = ref(null);

const id = ref(0);
const viewSelect = ref('Resume');
const TaskName = ref('');
const description = ref('');
const location = ref('');
const access_link = ref('');
const hour = ref('');
const situation = ref('');
const priority = ref('');
const responsible = ref({});
const attachments = ref([]);
const CheckList = ref([]);
const editCard = ref(false);
const usersAll = ref([]);
const users = ref([]);
const ModelUser = ref([]);
const Data = ref({});
const formatedDates = ref('');
const editDate = ref('');
const logsAll = ref([]);

const EditNameTask = ref('');
const EditDescriptionTask = ref('');
const Edithour = ref('');
const EditPlace = ref('');
const EditPlaceLink = ref('');
const EditPriority = ref('');
const EditSituation = ref('');
const EditAttachments = ref([]);
const EditTack = ref([]);
const ToRemove = ref([]);
const Editusers = ref([]);

const situationChose = ref([
  { label: 'À iniciar', value: '1' },
  { label: 'Em andamento', value: '2' },
  { label: 'Concluída', value: '3' },
  { label: 'Bloqueado', value: '4' }
]);

const priorityLabels = ref([
  { label: 'Baixa', value: 1 },
  { label: 'Média', value: 2 },
  { label: 'Alta', value: 3 }
]);

watch(ModelUser, async (value) => {
  if (!id.value) return;
  users.value = [];
  value.forEach(userId => {
    usersAll.value.forEach(userAll => {
      if (userId === userAll.id) {
        users.value.push(userAll);
      }
    });
  });

  try {
    await kanbanStore.updateTask(id.value, {
      users: users.value.map(u => u.id)
    });
    emit('taskDescription');
  } catch (error) {
    console.error('Erro ao atualizar convidados:', error);
  }
});

const formatDate = (value) => {
  if (!value) return '';
  moment.locale('pt-br');
  return moment(value).format('dddd, DD [de] MMMM');
};

const formatdateToEdit = (value) => {
  moment.locale('en-us');
  editDate.value = moment(value).format('yyyy-MM-DD');
};

const formatHour = (value) => {
  if (value === '00:00:00' || !value) {
    return 'Não informado';
  } else {
    return moment(value, 'HH:mm:ss').format('HH:mm');
  }
};

const openTask = (value) => {
  const dataUser = [];
  const modelUserList = [];
  id.value = value.id;
  TaskName.value = value.title;
  logsAll.value = value.logs ? [...value.logs].reverse() : [];
  description.value = value.description;
  location.value = value.location;
  access_link.value = value.access_link;
  formatedDates.value = value.date;
  formatdateToEdit(value.date);
  hour.value = value.hour;
  situation.value = String(value.situation || '1');
  priority.value = String(value.priority || '1');
  responsible.value = value.responsible || {};
  viewSelect.value = 'Resume';
  attachments.value = value.attachments || [];
  CheckList.value = value.checklists || [];
  Store.EditresponsableTask = value.responsible || {};
  editCard.value = false;

  if (value.users) {
    value.users.forEach(u => {
      dataUser.push(u);
      modelUserList.push(u.id);
    });
  }

  const SlotUsers = [];
  if (Store.users) {
    Store.users.forEach(u => {
      SlotUsers.push({
        ...u,
        value: u.id,
        label: u.name
      });
    });
  }

  usersAll.value = SlotUsers;
  users.value = dataUser;
  ModelUser.value = modelUserList;
  Data.value = value;

  if (viewDocument.value) {
    viewDocument.value.openModal();
  }
};

const RemoveCard = () => {
  if (ModalDeleteRef.value) {
    ModalDeleteRef.value.openModalDelete(id.value, TaskName.value);
  }
};

const CopyCard = () => {
  if (ModalCopyRef.value) {
    ModalCopyRef.value.openModalCopy(id.value);
  }
};

const addAttachment = (event) => {
  const files = Array.from(event.target.files);
  const newFiles = files.filter(file =>
    !EditTack.value.some(existingFile => existingFile.name === file.name)
  );

  EditAttachments.value.push(...newFiles.map(file => ({ name: file.name })));
  EditTack.value.push(...newFiles);
};

const removeAttachment = (index) => {
  if (EditTack.value[index] && EditTack.value[index].id) {
    ToRemove.value.push(EditTack.value[index].id);
  }
  EditAttachments.value.splice(index, 1);
  EditTack.value.splice(index, 1);
};

const openFileInput = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
};

const editCardModel = () => {
  editCard.value = true;
  EditNameTask.value = TaskName.value;
  EditDescriptionTask.value = description.value;
  Edithour.value = formatHour(hour.value);
  EditPlace.value = location.value;
  EditPlaceLink.value = access_link.value;
  EditPriority.value = priority.value;
  EditSituation.value = situation.value;
  EditTack.value = [...attachments.value];
  Editusers.value = [...users.value];
};

const editResponsable = () => {
  if (modalResponsable.value) {
    modalResponsable.value.openModalEdit();
  }
};

const EditTask = async () => {
  const userIds = Editusers.value.map(u => u.id);
  const formData = new FormData();
  formData.append('_method', 'PUT');
  formData.append('title', EditNameTask.value);
  formData.append('description', EditDescriptionTask.value || '');
  formData.append('date', editDate.value);
  
  if (Edithour.value === 'Não informado') {
    formData.append('hour', '00:00');
  } else {
    formData.append('hour', Edithour.value);
  }

  formData.append('location', EditPlace.value || '');
  if (EditPlaceLink.value != null) {
    formData.append('access_link', EditPlaceLink.value);
  }
  
  if (typeof EditPriority.value === 'object' && EditPriority.value !== null) {
    formData.append('priority', EditPriority.value.value);
  } else {
    formData.append('priority', EditPriority.value);
  }

  if (typeof EditSituation.value === 'object' && EditSituation.value !== null) {
    formData.append('situation', EditSituation.value.value);
  } else {
    formData.append('situation', EditSituation.value);
  }

  if (Store.EditresponsableTask && Store.EditresponsableTask.id) {
    formData.append('responsible_id', Store.EditresponsableTask.id);
  }

  userIds.forEach(uId => {
    formData.append('users[]', uId);
  });

  if (attachments.value.length >= 1) {
    attachments.value.forEach(att => {
      if (att.id) {
        formData.append('old_attachments[]', att.id);
      }
    });
  }

  EditTack.value.forEach(att => {
    if (!att.id) {
      formData.append('new_attachments[]', att);
    }
  });

  try {
    await kanbanStore.editTaskFormData(id.value, formData);
    editCard.value = false;
    emit('taskDescription');
    if (viewDocument.value) {
      viewDocument.value.closeModal();
    }
  } catch (error) {
    console.error('Erro ao editar tarefa:', error);
  }
};

const printPdf = (value, despacho) => {
  const printPdfWindow = window.open(Store.host + despacho.file_path, '', 'width=800,height=600');
  if (printPdfWindow) {
    printPdfWindow.onload = () => {
      printPdfWindow.print();
    };
  }
};

defineExpose({
  openTask
});
</script>

<template>
  <div>
    <ModalCopy ref="ModalCopyRef" />
    <ModalDelete ref="ModalDeleteRef" />
    <ModalResponsable ref="modalResponsable" />

    <ModalMain ref="viewDocument">
      <template #header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <h5 class="m-0 font-docs font-weight-bold" style="font-size: 20px; color: #212529;">
            {{ editCard ? 'Editar atividade' : (Data.is_event ? 'Evento' : 'Atividade') }}
          </h5>

          <div class="d-flex align-items-center gap-3">
            <button
              v-if="!editCard && Store.EditresponsableTask?.id === Store.user?.id"
              type="button"
              class="btn-header-action"
              @click="editCardModel"
              title="Editar"
            >
              <i class="fa-solid fa-pen"></i>
            </button>
            <button
              v-if="!editCard && Store.EditresponsableTask?.id === Store.user?.id"
              type="button"
              class="btn-header-action"
              @click="RemoveCard"
              title="Excluir"
            >
              <i class="fa-solid fa-trash-can"></i>
            </button>
            <button
              v-if="!editCard && Store.EditresponsableTask?.id === Store.user?.id"
              type="button"
              class="btn-header-action"
              @click="CopyCard"
              title="Copiar"
            >
              <i class="fa-regular fa-copy"></i>
            </button>
            <button
              id="close"
              type="button"
              class="close ml-2"
              @click="viewDocument.closeModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <template #body>
        <div class="modal-form font-docs">
          <div class="row g-0">
            <div class="col-12 col-md-3 pr-md-3 mb-3 mb-md-0 border-right-md">
              <div class="nav-sidebar d-flex flex-md-column gap-1">
                <button
                  type="button"
                  :class="['nav-sidebar-item', viewSelect === 'Resume' ? 'nav-sidebar-item--active' : '']"
                  @click="viewSelect = 'Resume'"
                >
                  <i class="fa-regular fa-newspaper mr-2"></i> Resumo
                </button>
                <button
                  type="button"
                  :class="['nav-sidebar-item', viewSelect === 'Files' ? 'nav-sidebar-item--active' : '']"
                  @click="viewSelect = 'Files'"
                >
                  <i class="fa-solid fa-link mr-2"></i> Arquivos
                </button>
                <button
                  type="button"
                  :class="['nav-sidebar-item', viewSelect === 'Convidados' ? 'nav-sidebar-item--active' : '']"
                  @click="viewSelect = 'Convidados'"
                >
                  <i class="fa-solid fa-users mr-2"></i> Convidados
                </button>
                <button
                  type="button"
                  :class="['nav-sidebar-item', viewSelect === 'timeline' ? 'nav-sidebar-item--active' : '']"
                  @click="viewSelect = 'timeline'"
                >
                  <i class="fa-regular fa-clock mr-2"></i> Histórico
                </button>
              </div>
            </div>

            <div class="col-12 col-md-9 pl-md-3">
              <div v-if="viewSelect === 'Resume'">
                <template v-if="!editCard">
                  <h6 class="font-weight-bold text-dark mb-3" style="font-size: 16px; word-break: break-word; overflow-wrap: anywhere;">
                    {{ TaskName }}
                  </h6>

                  <div v-if="access_link" class="mb-3">
                    <a :href="access_link" target="_blank" class="btn-invite-link">
                      <i class="fa-solid fa-share-nodes mr-1"></i> Convidar por link
                    </a>
                  </div>

                  <div class="row g-2 mb-3">
                    <div class="col-12 col-md-6">
                      <div class="d-flex align-items-start">
                        <i class="fa-regular fa-calendar-check mr-2 text-muted mt-1" style="font-size: 16px;"></i>
                        <div>
                          <span class="d-block font-weight-bold text-dark" style="font-size: 13px;">Data e hora</span>
                          <span class="text-secondary" style="font-size: 13px;">
                            {{ formatDate(formatedDates) }} - {{ formatHour(hour) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-md-3">
                      <span class="d-block font-weight-bold text-dark mb-1" style="font-size: 13px;">Situação</span>
                      <Tag v-if="situation === '1'" rounded style="background-color: #E9ECEF; color: #6C757D; padding: 3px 12px;">
                        <span class="text-xs font-docs"><b>À iniciar</b></span>
                      </Tag>
                      <Tag v-if="situation === '2'" rounded style="background-color: #CFF4FC; color: #087990; padding: 3px 12px;">
                        <span class="text-xs font-docs"><b>Em andamento</b></span>
                      </Tag>
                      <Tag v-if="situation === '4'" rounded style="background-color: #F8D7DA; color: #842029; padding: 3px 12px;">
                        <span class="text-xs font-docs"><b>Bloqueada</b></span>
                      </Tag>
                      <Tag v-if="situation === '3'" rounded style="background-color: rgba(9, 167, 6, 0.1); color: rgb(9, 167, 6); padding: 3px 12px;">
                        <span class="text-xs font-docs"><b>Concluída</b></span>
                      </Tag>
                    </div>

                    <div class="col-6 col-md-3">
                      <span class="d-block font-weight-bold text-dark mb-1" style="font-size: 13px;">Prioridade</span>
                      <div v-if="priority === '1'" class="d-flex align-items-center">
                        <i class="fa-solid fa-angle-up mr-1" style="color: #0D6EFD;"></i>
                        <span style="font-size: 13px;">Baixa</span>
                      </div>
                      <div v-if="priority === '2'" class="d-flex align-items-center">
                        <div class="d-flex flex-column align-items-center justify-content-center mr-1" style="color: #FFC107; line-height: 0.2;">
                          <i class="fa-solid fa-angle-up" style="font-size: 10px; margin-bottom: -6px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 10px;"></i>
                        </div>
                        <span style="font-size: 13px;">Média</span>
                      </div>
                      <div v-if="priority === '3'" class="d-flex align-items-center">
                        <div class="d-flex flex-column align-items-center justify-content-center mr-1" style="color: #F76659; line-height: 0.2;">
                          <i class="fa-solid fa-angle-up" style="font-size: 10px; margin-bottom: -6px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 10px; margin-bottom: -6px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 10px;"></i>
                        </div>
                        <span style="font-size: 13px;">Alta</span>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3" v-if="description">
                    <div class="d-flex align-items-start">
                      <i class="fa-solid fa-bars-staggered mr-2 text-muted mt-1" style="font-size: 16px;"></i>
                      <div>
                        <span class="d-block font-weight-bold text-dark" style="font-size: 13px;">Descrição</span>
                        <p class="text-secondary m-0" style="font-size: 13px; white-space: pre-line;">{{ description }}</p>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3" v-if="location || access_link">
                    <div class="d-flex align-items-start">
                      <i class="fa-solid fa-location-dot mr-2 text-muted mt-1" style="font-size: 16px;"></i>
                      <div>
                        <span class="d-block font-weight-bold text-dark" style="font-size: 13px;">Local</span>
                        <span class="text-secondary d-block" style="font-size: 13px;">{{ location || 'Não informado' }}</span>
                        <a v-if="access_link" :href="access_link" target="_blank" class="text-primary text-break" style="font-size: 12px;">{{ access_link }}</a>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <span class="d-block font-weight-bold text-dark mb-1" style="font-size: 13px;">Responsável</span>
                    <div class="d-flex align-items-center">
                      <img
                        :src="$userAvatar(responsible?.path_image)"
                        alt="Avatar"
                        class="mr-2"
                        style="width: 34px; height: 34px; border-radius: 50%; object-fit: cover;"
                      />
                      <div class="d-flex flex-column">
                        <span class="font-weight-bold text-dark" style="font-size: 13px; line-height: 1.2;">{{ responsible?.name }}</span>
                        <span class="text-muted" style="font-size: 11px; line-height: 1.2;">{{ responsible?.email }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <TodoListUpdated ref="TodoListUpdatedRef" :ExistCheckList="CheckList" :TaskID="id" />
                  </div>

                  <div class="mb-3" v-if="users && users.length > 0">
                    <span class="d-block font-weight-bold text-dark mb-1" style="font-size: 13px;">Convidados</span>
                    <div class="d-flex align-items-center gap-1">
                      <img
                        v-for="(u, uIdx) in users.slice(0, 4)"
                        :key="uIdx"
                        :src="$userAvatar(u.path_image)"
                        :title="u.name"
                        style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover; border: 2px solid #fff;"
                      />
                      <span v-if="users.length > 4" class="badge rounded-pill bg-light text-dark border" style="font-size: 11px;">
                        +{{ users.length - 4 }}
                      </span>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div class="row g-2 mb-3">
                    <div class="col-12 col-md-3">
                      <label class="label-custom">Data <span class="text-danger">*</span></label>
                      <input type="date" class="input-custom" v-model="editDate" />
                    </div>
                    <div class="col-12 col-md-3">
                      <label class="label-custom">Horário</label>
                      <input type="time" class="input-custom" v-model="Edithour" />
                    </div>
                    <div class="col-12 col-md-3">
                      <label class="label-custom">Situação <span class="text-danger">*</span></label>
                      <Dropdown
                        v-model="EditSituation"
                        :options="situationChose"
                        optionLabel="label"
                        placeholder="Selecione um status"
                        class="w-100 custom-dropdown"
                      >
                        <template #value="slotProps">
                          <div v-if="slotProps.value" class="d-flex align-items-center">
                            <Tag v-if="slotProps.value === '1' || slotProps.value?.value === '1'" rounded style="background-color: #E9ECEF; color: #6C757D; padding: 3px 12px;">
                              <span class="text-xs font-docs"><b>À iniciar</b></span>
                            </Tag>
                            <Tag v-if="slotProps.value === '2' || slotProps.value?.value === '2'" rounded style="background-color: #CFF4FC; color: #087990; padding: 3px 12px;">
                              <span class="text-xs font-docs"><b>Em andamento</b></span>
                            </Tag>
                            <Tag v-if="slotProps.value === '4' || slotProps.value?.value === '4'" rounded style="background-color: #F8D7DA; color: #842029; padding: 3px 12px;">
                              <span class="text-xs font-docs"><b>Bloqueada</b></span>
                            </Tag>
                            <Tag v-if="slotProps.value === '3' || slotProps.value?.value === '3'" rounded style="background-color: rgba(9, 167, 6, 0.1); color: rgb(9, 167, 6); padding: 3px 12px;">
                              <span class="text-xs font-docs"><b>Concluída</b></span>
                            </Tag>
                          </div>
                        </template>
                        <template #option="{ option }">
                          <Tag v-if="option.label === 'À iniciar'" rounded style="background-color: #E9ECEF; color: #6C757D; padding: 3px 12px;">
                            <span class="text-xs font-docs"><b>{{ option.label }}</b></span>
                          </Tag>
                          <Tag v-if="option.label === 'Em andamento'" rounded style="background-color: #CFF4FC; color: #087990; padding: 3px 12px;">
                            <span class="text-xs font-docs"><b>{{ option.label }}</b></span>
                          </Tag>
                          <Tag v-if="option.label === 'Bloqueado'" rounded style="background-color: #F8D7DA; color: #842029; padding: 3px 12px;">
                            <span class="text-xs font-docs"><b>{{ option.label }}</b></span>
                          </Tag>
                          <Tag v-if="option.label === 'Concluída'" rounded style="background-color: rgba(9, 167, 6, 0.1); color: rgb(9, 167, 6); padding: 3px 12px;">
                            <span class="text-xs font-docs"><b>{{ option.label }}</b></span>
                          </Tag>
                        </template>
                      </Dropdown>
                    </div>

                    <div class="col-12 col-md-3">
                      <label class="label-custom">Prioridade</label>
                      <Dropdown
                        v-model="EditPriority"
                        :options="priorityLabels"
                        optionLabel="label"
                        placeholder="Selecione a prioridade"
                        class="w-100 custom-dropdown"
                      >
                        <template #value="slotProps">
                          <div v-if="slotProps.value" class="d-flex align-items-center">
                            <div v-if="slotProps.value === '1' || slotProps.value?.value === 1 || slotProps.value?.label === 'Baixa'" class="d-flex align-items-center">
                              <i class="fa-solid fa-angle-up mr-1" style="color: #0D6EFD;"></i>
                              <span style="font-size: 13px;">Baixa</span>
                            </div>
                            <div v-if="slotProps.value === '2' || slotProps.value?.value === 2 || slotProps.value?.label === 'Média'" class="d-flex align-items-center">
                              <div class="d-flex flex-column align-items-center justify-content-center mr-1" style="color: #FFC107; line-height: 0.2;">
                                <i class="fa-solid fa-angle-up" style="font-size: 10px; margin-bottom: -6px;"></i>
                                <i class="fa-solid fa-angle-up" style="font-size: 10px;"></i>
                              </div>
                              <span style="font-size: 13px;">Média</span>
                            </div>
                            <div v-if="slotProps.value === '3' || slotProps.value?.value === 3 || slotProps.value?.label === 'Alta'" class="d-flex align-items-center">
                              <div class="d-flex flex-column align-items-center justify-content-center mr-1" style="color: #F76659; line-height: 0.2;">
                                <i class="fa-solid fa-angle-up" style="font-size: 10px; margin-bottom: -6px;"></i>
                                <i class="fa-solid fa-angle-up" style="font-size: 10px; margin-bottom: -6px;"></i>
                                <i class="fa-solid fa-angle-up" style="font-size: 10px;"></i>
                              </div>
                              <span style="font-size: 13px;">Alta</span>
                            </div>
                          </div>
                        </template>
                      </Dropdown>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="label-custom">Nome <span class="text-danger">*</span></label>
                    <input type="text" class="input-custom" v-model="EditNameTask" placeholder="Nome da tarefa" />
                  </div>

                  <div class="mb-3">
                    <label class="label-custom">Descrição</label>
                    <textarea v-model="EditDescriptionTask" class="textarea-custom" placeholder="Descrição da tarefa" rows="3"></textarea>
                  </div>

                  <div class="row g-2 mb-3">
                    <div class="col-12 col-md-6">
                      <label class="label-custom">Local da reunião</label>
                      <input type="text" v-model="EditPlace" class="input-custom" placeholder="Local" />
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="label-custom">Link de acesso à videoconferência</label>
                      <input type="text" v-model="EditPlaceLink" class="input-custom" placeholder="https://meet.google.com/" />
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="label-custom">Responsável</label>
                    <div class="responsable-box d-flex align-items-center justify-content-between p-2">
                      <div class="d-flex align-items-center text-truncate">
                        <img
                          :src="$userAvatar(Store.EditresponsableTask?.path_image)"
                          alt="Avatar"
                          class="responsable-avatar mr-2"
                        />
                        <div class="d-flex flex-column text-truncate">
                          <span class="responsable-name text-truncate"><b>{{ Store.EditresponsableTask?.name }}</b></span>
                          <span class="responsable-email text-truncate">{{ Store.EditresponsableTask?.email }}</span>
                        </div>
                      </div>
                      <i class="fa-solid fa-pen edit-responsable-icon ml-2" @click="editResponsable" title="Editar responsável"></i>
                    </div>
                  </div>

                  <div class="mb-3">
                    <TodoListUpdated ref="TodoListUpdatedRef" :ExistCheckList="CheckList" :TaskID="id" />
                  </div>
                </template>
              </div>

              <div v-if="viewSelect === 'Files'">
                <div v-if="!editCard" class="files-list">
                  <span class="d-block font-weight-bold text-dark mb-2" style="font-size: 14px;">Anexos</span>
                  <div v-if="attachments.length > 0">
                    <div v-for="(attachment, index) in attachments" :key="index" class="attachment-item d-flex align-items-center justify-content-between mb-2">
                      <div class="d-flex align-items-center text-truncate">
                        <i class="fa-regular fa-file mr-2 text-muted"></i>
                        <span class="text-truncate">{{ attachment.name }}</span>
                      </div>
                      <button type="button" class="btn-icon-action" @click="printPdf(3, attachment)" title="Baixar">
                        <i class="fa-solid fa-download"></i>
                      </button>
                    </div>
                  </div>
                  <span v-else class="text-muted" style="font-size: 13px;">Nenhum anexo nessa atividade</span>
                </div>

                <div v-else>
                  <button type="button" class="btn-outline-attachment mb-3" @click="openFileInput">
                    <i class="fa-solid fa-arrow-up-from-bracket mr-2"></i> Adicionar arquivo
                  </button>
                  <input type="file" ref="fileInput" @change="addAttachment" accept=".doc,.docx,.odt,.pdf,.png,.jpg,.svg" style="display: none" multiple />

                  <div v-if="EditTack.length > 0" class="attachments-list">
                    <div v-for="(attachment, index) in EditTack" :key="index" class="attachment-item d-flex align-items-center justify-content-between mb-2">
                      <div class="d-flex align-items-center text-truncate">
                        <i class="fa-regular fa-file mr-2 text-muted"></i>
                        <span class="text-truncate">{{ attachment.name }}</span>
                      </div>
                      <button type="button" class="btn-icon-remove" @click="removeAttachment(index)" title="Remover">
                        <i class="fa-regular fa-trash-can"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="viewSelect === 'Convidados'">
                <span class="d-block font-weight-bold text-dark mb-2" style="font-size: 14px;">Convidados</span>

                <div v-if="!editCard">
                  <div v-for="user in users" :key="user.id || user" class="d-flex align-items-center mb-2">
                    <img :src="$userAvatar(user?.path_image)" alt="Avatar" class="mr-2" style="width: 32px; height: 32px; border-radius: 50%; object-fit: cover;" />
                    <div class="d-flex flex-column">
                      <span class="font-weight-bold text-dark" style="font-size: 13px; line-height: 1.2;">{{ user.name }}</span>
                      <span class="text-muted" style="font-size: 11px; line-height: 1.2;">{{ user.email }}</span>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <MultiSelectPrime
                    display="chip"
                    v-model="Editusers"
                    :options="Store.users"
                    filter optionLabel="name"
                    placeholder="Busque por nome, e-mail ou setor..."
                    :maxSelectedLabels="3"
                    class="w-100 custom-multiselect"
                  >
                    <template #option="slotProps">
                      <div class="d-flex align-items-center py-1">
                        <img :alt="slotProps.option.name" :src="$userAvatar(slotProps.option.path_image)" class="mr-2" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;" />
                        <div class="d-flex flex-column">
                          <span style="font-size: 13px; font-weight: 600; line-height: 1.2;">{{ slotProps.option.name }}</span>
                          <span style="font-size: 11px; color: #6c757d; line-height: 1.2;">{{ slotProps.option.email }}</span>
                        </div>
                      </div>
                    </template>
                  </MultiSelectPrime>
                </div>
              </div>

              <div v-if="viewSelect === 'timeline'">
                <span class="d-block font-weight-bold text-dark mb-3" style="font-size: 14px;">Histórico de atividade</span>
                <Timeline :value="logsAll">
                  <template #opposite="slotProps">
                    <small class="text-muted" style="font-size: 11px;">{{ formatDate(slotProps.item.created_at) }}</small>
                  </template>
                  <template #content="slotProps">
                    <div class="d-flex flex-column">
                      <strong style="font-size: 12px; color: #212529;">{{ slotProps.item.user?.name }}</strong>
                      <span class="text-secondary" style="font-size: 12px;">{{ slotProps.item.message }}</span>
                    </div>
                  </template>
                </Timeline>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div v-if="editCard" class="d-flex justify-content-end gap-2 mt-3">
          <button type="button" class="btn btn-outline-action font-docs" @click="editCard = false">
            Cancelar
          </button>
          <button type="button" class="btn btn-solid-action font-docs" @click="EditTask">
            Salvar alterações
          </button>
        </div>
      </template>
    </ModalMain>
  </div>
</template>

<style scoped>
.font-docs {
  font-family: inherit;
}

.border-right-md {
  border-right: 1px solid #e9ecef;
}

.btn-header-action {
  background: transparent;
  border: none;
  color: #F1860B;
  font-size: 18px;
  cursor: pointer;
  padding: 2px 6px;
  transition: color 0.15s;
}

.btn-header-action:hover {
  color: #d97405;
}

.nav-sidebar-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #6c757d;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}

.nav-sidebar-item:hover {
  background-color: #f8f9fa;
  color: #212529;
}

.nav-sidebar-item--active {
  background-color: #f8f9fa !important;
  color: #F1860B !important;
}

.btn-invite-link {
  display: inline-flex;
  align-items: center;
  border: 1px solid #F1860B;
  color: #F1860B;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.15s;
}

.btn-invite-link:hover {
  background-color: rgba(241, 134, 11, 0.08);
  color: #d97405;
}

.label-custom {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 4px;
  display: block;
}

.input-custom {
  width: 100%;
  height: 40px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  background-color: #ffffff;
  color: #212529;
  outline: none;
}

.textarea-custom {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  background-color: #ffffff;
  color: #212529;
  outline: none;
  resize: vertical;
}

.responsable-box {
  border: 1px solid #ced4da;
  border-radius: 6px;
  min-height: 40px;
  background-color: #ffffff;
}

.responsable-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.edit-responsable-icon {
  color: #F1860B;
  cursor: pointer;
  font-size: 15px;
}

.attachment-item {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
}

.btn-icon-action {
  background: transparent;
  border: none;
  color: #F1860B;
  cursor: pointer;
  padding: 2px 6px;
}

.btn-icon-remove {
  background: transparent;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 2px 6px;
}

.btn-outline-attachment {
  border: 1px solid #F1860B;
  color: #F1860B;
  background: transparent;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.btn-outline-action {
  color: #F1860B;
  border: 1px solid #F1860B;
  background: transparent;
  font-weight: 600;
  padding: 6px 18px;
  border-radius: 6px;
}

.btn-solid-action {
  background-color: #F1860B;
  color: #ffffff;
  border: 1px solid #F1860B;
  font-weight: 600;
  padding: 6px 22px;
  border-radius: 6px;
}

:deep(.custom-dropdown.p-dropdown),
:deep(.custom-multiselect.p-multiselect) {
  height: 40px !important;
  border-radius: 6px !important;
  border-color: #ced4da !important;
  align-items: center;
}
</style>